<template>
  <v-layout>
    <d-header fluid>
      <h1 class="title">
        {{ $t("property_logs") }}
      </h1>
    </d-header>

    <v-property-log-list />
  </v-layout>
</template>

<script>
import list from "./_list.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("property_logs").capitalize(),
    };
  },
  components: {
    "v-property-log-list": list,
  },
};
</script>
